import auth from '@/router/auth'
import ClassLiveIndex from '@/components/test-rooms/Index'
import ClassLiveShow from '@/components/test-rooms/Show'
import ClassLiveCreate from '@/components/test-rooms/Create'
// import BookingUpdate from '@/components/bookings/Update'
// import BookingShow from '@/components/bookings/Show'

export default [
  {
    path: '/test-rooms',
    name: 'test-room-index',
    component: ClassLiveIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-room/create',
    name: 'test-room-create',
    component: ClassLiveCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/test-room-show/:id',
    name: 'test-room-show',
    component: ClassLiveShow,
    beforeEnter: auth.requireAuth
  }, {
    path: '/test-room-create-of-class/:id',
    name: 'test-room-create-of-class',
    component: ClassLiveCreate,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/test-rooms/router.js